module.exports = __webpack_public_path__ + "img/pic0.a856876c.png";